import type { LayerCatalogItem } from '../api'
import { layerLabel, useT } from '../i18n'
import { Icon, type IconName } from '../brand/Icon'
import { earthquakeColor } from '../map/layerOrder'

interface OverlayTogglesProps {
  layers: LayerCatalogItem[]
  active: string[]
  onToggle: (id: string) => void
}

const OVERLAY_ICON: Record<string, IconName> = {
  ice: 'ic-ice',
  sea_fog: 'ic-fog',
  clouds: 'ic-clouds',
  earthquakes: 'ic-earthquakes',
  moon: 'ic-moon',
  // Своей иконки у рубежей нет; общий «слои» честнее чужого символа.
  eez: 'ic-layers',
  fishing_districts: 'ic-layers',
  substrate: 'ic-bathymetry',
  navwarn: 'ic-sec-navwarn',
}

export function OverlayToggles({ layers, active, onToggle }: OverlayTogglesProps) {
  // Хук нужен ради подписки на смену языка: сами подписи берёт layerLabel.
  useT()
  const overlays = layers.filter(l => l.overlay)
  if (overlays.length === 0) return null
  return (
    <div>
      {/* Заголовок «Оверлеи» убран: блок уже называется «Наложения» (синоним) — дублировать незачем. */}
      <div className="flex flex-col gap-0.5">
        {overlays.map(o => {
          const on = active.includes(o.id)
          return (
            <button
              key={o.id}
              type="button"
              role="switch"
              aria-checked={on}
              onClick={() => onToggle(o.id)}
              className="flex items-center gap-3 rounded-lg px-2 py-2 text-left text-sm text-foam transition-colors hover:bg-haze"
            >
              <span
                aria-hidden
                className={[
                  'relative h-[19px] w-[34px] flex-shrink-0 rounded-full transition-colors',
                  on ? 'bg-sonar-dim' : 'bg-hull',
                ].join(' ')}
              >
                <span
                  className={[
                    'absolute top-0.5 h-[15px] w-[15px] rounded-full transition-all',
                    on ? 'left-[17px] bg-deep' : 'left-0.5 bg-mist',
                  ].join(' ')}
                />
              </span>
              {/* Легенда землетрясений — прямо в подписи тумблера: отдельной
                  строкой она занимала высоту панели ради одной точки
                  (фидбек владельца 2026-08-07). Цвет — тот же, что на карте. */}
              <span className="flex-1">
                {layerLabel(o.id)}
                {o.id === 'earthquakes' && (
                  <span className="ml-1 text-faint">
                    (
                    <span
                      aria-hidden
                      className="inline-block h-1.5 w-1.5 rounded-full align-middle"
                      style={{ background: earthquakeColor() }}
                    />
                    )
                  </span>
                )}
              </span>
              <Icon
                name={OVERLAY_ICON[o.id] ?? 'ic-layers'}
                className={['h-[18px] w-[18px]', on ? 'text-sonar' : 'text-mist'].join(' ')}
              />
            </button>
          )
        })}
      </div>
    </div>
  )
}
